export default __webpack_public_path__ + "static/media/tacos.63fcba90.jpg";